module.exports = __webpack_public_path__ + "img/comment1.b4bbf3d6.png";